import React from 'react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator, DropdownMenuLabel } from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { MoreHorizontal, UserPlus, Search, ShieldCheck, Download, Ticket, FileCode, FileText, BookOpen } from 'lucide-react';
import { toast } from 'sonner';

const ACTIONS = [
  { key: 'assign', label: 'Assign Owner', icon: UserPlus },
  { key: 'investigate', label: 'Start Investigation', icon: Search },
  { key: 'suppress', label: 'Approve Suppression', icon: ShieldCheck },
  { key: 'export', label: 'Export Evidence', icon: Download },
  { key: 'ticket', label: 'Create ServiceNow Ticket', icon: Ticket },
  { key: 'guardrail', label: 'Generate Terraform Guardrail', icon: FileCode },
  { key: 'board', label: 'Add to Board Report', icon: BookOpen },
  { key: 'policy', label: 'Generate Policy', icon: FileText },
];

export default function ActionMenu({ context = 'finding', size = 'sm', testId }) {
  const handle = (key, label) => {
    toast.success(`${label} queued`, { description: `Context: ${context}` });
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size={size === 'sm' ? 'sm' : 'default'} className="h-8 gap-1.5 text-xs" data-testid={testId ?? 'action-menu-trigger'}>
          Actions
          <MoreHorizontal className="w-3.5 h-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-wider text-apex-neutral">Standard actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {ACTIONS.map((a) => {
          const Icon = a.icon;
          return (
            <DropdownMenuItem key={a.key} onSelect={() => handle(a.key, a.label)} className="text-xs gap-2">
              <Icon className="w-3.5 h-3.5 text-apex-lens" />
              {a.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
